import { render, staticRenderFns } from "./MessageIntermediateThrowEvent.vue?vue&type=template&id=21026cb9&scoped=true&"
import script from "./MessageIntermediateThrowEvent.vue?vue&type=script&lang=js&"
export * from "./MessageIntermediateThrowEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21026cb9",
  null
  
)

export default component.exports